"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function WhoWeAre() {
  const imageRef = useRef<HTMLDivElement>(null);
  const [scrollY, setScrollY] = useState(0);
  const {
    ref: textRef1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: textRef2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: textRef3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.3
  });
  useEffect(() => {
    const handleScroll = () => {
      if (imageRef.current) {
        const rect = imageRef.current.getBoundingClientRect();
        const elementTop = rect.top;
        const elementHeight = rect.height;
        const windowHeight = window.innerHeight;
        if (elementTop < windowHeight && elementTop + elementHeight > 0) {
          const scrollPercentage = (windowHeight - elementTop) / (windowHeight + elementHeight);
          setScrollY(scrollPercentage);
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const imageScale = 1 + scrollY * 0.01;
  return <section id="kim-jesteśmy" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {}
          <div ref={imageRef} className="relative overflow-hidden rounded-md shadow-soft aspect-[3/4] lg:aspect-[4/5]">
            <div className="absolute inset-0 transition-transform duration-700 ease-out" style={{
            transform: `scale(${imageScale})`,
            transformOrigin: "center center"
          }}>
              <img src="https://odszkodowaniaslupsk.info/wp-content/uploads/2026/03/image_r8b9tvu5.png" alt="Zespół Odszkodowania Słupsk" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-dark-background/20 to-transparent" />
            </div>
          </div>

          {}
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-px bg-border opacity-30" style={{
          transform: "translateX(-50%)"
        }} />

          {}
          <div className="space-y-8 lg:space-y-12">
            <div ref={textRef1} className="transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" style={{
            opacity: isVisible1 ? 1 : 0,
            transform: isVisible1 ? "translateY(0)" : "translateY(20px)"
          }}>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-semibold tracking-tight leading-tight mb-6 text-foreground">
                Kim jesteśmy
              </h2>
              <p className="text-lg md:text-xl leading-relaxed text-muted-foreground">Jesteśmy pełnomocnikami Kancelarii Adwokatów i Radców Prawnych, zajmującymi się prowadzeniem spraw dotyczących dochodzenia odszkodowań i zadośćuczynień dla osób poszkodowanych w wypadkach oraz dla członków ich rodzin.</p>
            </div>

            <div ref={textRef2} className="transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100" style={{
            opacity: isVisible2 ? 1 : 0,
            transform: isVisible2 ? "translateY(0)" : "translateY(20px)"
          }}>
              <h3 className="text-2xl md:text-3xl font-display font-semibold mb-4 text-foreground">
                Nasza misja
              </h3>
              <p className="text-base md:text-lg leading-relaxed text-muted-foreground">Działamy na terenie Słupska i okolic, oferując rzetelną obsługę prawną na etapie przedsądowym i sądowym. Każdą sprawę analizujemy indywidualnie, łącząc wiedzę prawną z empatią. Zapewniamy wsparcie prawne na etapie postępowania przed ubezpieczycielem, a w razie potrzeby również w postępowaniu sądowym, dbając o prawidłowe przygotowanie dokumentacji oraz ochronę interesów osób poszkodowanych.</p>
            </div>

            <div ref={textRef3} className="transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-200" style={{
            opacity: isVisible3 ? 1 : 0,
            transform: isVisible3 ? "translateY(0)" : "translateY(20px)"
          }}>
              <h3 className="text-2xl md:text-3xl font-display font-semibold mb-4 text-foreground">
                Nasze wartości
              </h3>
              <p className="text-base md:text-lg leading-relaxed text-muted-foreground mb-6">
                W naszej pracy kierujemy się profesjonalizmem, rzetelnością i zrozumieniem dla trudnej sytuacji naszych klientów. Zapewniamy profesjonalne opinie prawne, wsparcie w kontaktach z ubezpieczycielem oraz reprezentację w różnych rodzajach wypadków i roszczeń.
              </p>
              <div className="flex flex-wrap gap-3">
                <span className="inline-block px-4 py-2 rounded-md bg-primary-light text-primary font-sans text-sm font-medium">
                  Profesjonalizm
                </span>
                <span className="inline-block px-4 py-2 rounded-md bg-primary-light text-primary font-sans text-sm font-medium">
                  Rzetelność
                </span>
                <span className="inline-block px-4 py-2 rounded-md bg-primary-light text-primary font-sans text-sm font-medium">
                  Empatia
                </span>
                <span className="inline-block px-4 py-2 rounded-md bg-primary-light text-primary font-sans text-sm font-medium">
                  Doświadczenie
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}